export default "__VITE_PUBLIC_ASSET__0be0319b__"